//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

/**
 * Form field IDs for the Product Details Modal.
 * These IDs are used to associate labels with their form controls for accessibility.
 */
export const PRODUCT_MODAL_FIELD_IDS = {
  BRAND: 'product-brand-field',
  BRAND_LABEL: 'product-brand-label',
  CATEGORY: 'product-category-field',
  CATEGORY_LABEL: 'product-category-label',
} as const;
